import React from "react";
import { Card, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { SubstancesIcons, substanceReplace } from "../../constants";

// A component for a single metric card
const MetricCard = ({ metricKey, value, summaryPage, icon = "humidity_light", color }: any) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Card
            sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                borderRadius: 2,
                bgcolor: "#fff",
                minWidth: 120,
                maxWidth: 225,
                cursor: "pointer",
                m: 1,
            }}
            onClick={() => summaryPage(metricKey)}
        >
            <Box
                sx={{
                    bgcolor: color,
                    p: 1,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    width: "35px",
                    height: "35px"
                }}
            >
                <img src={`/assets/images/${icon}.svg`} style={(color == "#871014" || color == "#000000") ? { "filter": "brightness(0) invert(1)" } : { "filter": "brightness(1) invert(0)" }} />
            </Box>
            <Box
                sx={{
                    display: isMobile ? "block" : "flex",
                    alignItems: "center",
                    gap: 0.5,
                    whiteSpace: "nowrap",
                    flexWrap: "wrap",
                    overflow: "hidden",
                }}
            >
                <Typography variant="body2" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
                    {metricKey} {isMobile ? "" : "|"}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {isNaN(Number(value)) ? value : Number(value).toFixed(2)}
                </Typography>

            </Box>
        </Card>
    );
};

const getRandomColor = () => {
    const colors = ["#98E565", "#FFEF5C", "#FF8F66", "#858585"];
    return colors[Math.floor(Math.random() * colors.length)];
};

// Container component that renders a card for every key in the metric object
const MetricsContainer = ({ metricData = {}, summaryPage }: any) => {
    return (
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {Object.keys(metricData).length > 0 ? (
                Object.entries(metricData).map(([key, value]) => (
                    <MetricCard
                        key={key}
                        metricKey={substanceReplace[key]}
                        value={value}
                        summaryPage={summaryPage}
                        color={getRandomColor()}
                        icon={SubstancesIcons[substanceReplace[key]]}
                    />
                ))
            ) : (
                <Typography variant="h6" sx={{ width: "100%", textAlign: "center", mt: 2 }}>
                    No data available
                </Typography>
            )}
        </Box>

    );
};


export default MetricsContainer;
